import React from "react";
import { useLang } from '../contexts/LanguageContext';
import { Container } from "react-bootstrap";
import NavbarHome from '../components/NavbarIndex';
import Footer from "../components/Footer";


export default function AboutUs() {

  /* Variable de traducción */
  const { t } = useLang();

  return (
    <div>
      <NavbarHome static_page="true" />
      <Container>
        <h1>{t("ABOUT_US_TITLE")}</h1>
        <p>{t("ABOUT_US_TEXT")}</p>
      </Container>
      <Footer />
    </div>
  );
}
